import React, { useState } from 'react';
import axios from 'axios';

function DebugRequests() {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    const testResults = {
      timestamp: new Date().toISOString(),
      tests: []
    };

    // Test 1: Check if token exists
    const token = localStorage.getItem('accessToken');
    testResults.tests.push({
      name: 'Token exists',
      passed: !!token,
      details: token ? 'Token found in localStorage' : 'No token found'
    });

    if (!token) {
      setResults(testResults);
      setLoading(false);
      return;
    }

    // Test 2: Decode token (basic check)
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      testResults.tests.push({
        name: 'Token decode',
        passed: true,
        details: `User ID: ${payload.userId}, Expires: ${new Date(payload.exp * 1000).toLocaleString()}`
      });
    } catch (e) {
      testResults.tests.push({
        name: 'Token decode',
        passed: false,
        details: 'Failed to decode token'
      });
    }

    // Test 3: Health check
    try {
      const health = await axios.get('/health');
      testResults.tests.push({
        name: 'Backend health',
        passed: health.status === 200,
        details: JSON.stringify(health.data)
      });
    } catch (e) {
      testResults.tests.push({
        name: 'Backend health',
        passed: false,
        details: e.message
      });
    }

    // Test 4: Get user info
    try {
      const user = await axios.get('/api/users/me', {
        headers: { Authorization: `Bearer ${token}` }
      });
      testResults.tests.push({
        name: 'Get user info',
        passed: true,
        details: `Logged in as: ${user.data.firstName} (User ID: ${user.data.userId})`
      });
    } catch (e) {
      testResults.tests.push({
        name: 'Get user info',
        passed: false,
        details: e.response?.data?.error || e.message
      });
    }

    // Test 5: Get received requests
    try {
      const requests = await axios.get('/api/connections/requests/received', {
        headers: { Authorization: `Bearer ${token}` }
      });
      testResults.tests.push({
        name: 'Get received requests',
        passed: true,
        details: `Found ${requests.data.requests.length} request(s)`,
        data: requests.data.requests
      });
    } catch (e) {
      testResults.tests.push({
        name: 'Get received requests',
        passed: false,
        details: e.response?.data?.error || e.message
      });
    }

    // Test 6: Get connections
    try {
      const connections = await axios.get('/api/connections', {
        headers: { Authorization: `Bearer ${token}` }
      });
      testResults.tests.push({
        name: 'Get connections',
        passed: true,
        details: `Found ${connections.data.connections.length} connection(s)`,
        data: connections.data.connections
      });
    } catch (e) {
      testResults.tests.push({
        name: 'Get connections',
        passed: false,
        details: e.response?.data?.error || e.message
      });
    }

    setResults(testResults);
    setLoading(false);
  };

  return (
    <div>
      <div className="navbar">
        <h1>🔧 Debug Requests</h1>
        <nav>
          <a href="/dashboard">Dashboard</a>
          <a href="/connections">Connections</a>
        </nav>
      </div>

      <div className="container">
        <div className="card">
          <h2>🔍 Connection Requests Debugger</h2>
          <p>This page helps diagnose why requests aren't showing up.</p>
          
          <button 
            onClick={runTests}
            disabled={loading}
            className="btn btn-primary"
            style={{ marginTop: '20px' }}
          >
            {loading ? 'Running Tests...' : 'Run Diagnostic Tests'}
          </button>
        </div>

        {results && (
          <div className="card">
            <h3>Test Results</h3>
            <p style={{ color: '#666', fontSize: '14px' }}>
              Run at: {new Date(results.timestamp).toLocaleString()}
            </p>

            {results.tests.map((test, index) => (
              <div 
                key={index}
                style={{
                  padding: '12px',
                  marginTop: '12px',
                  backgroundColor: test.passed ? '#d4edda' : '#f8d7da',
                  borderRadius: '6px',
                  border: `1px solid ${test.passed ? '#c3e6cb' : '#f5c6cb'}`
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '20px' }}>
                    {test.passed ? '✅' : '❌'}
                  </span>
                  <strong>{test.name}</strong>
                </div>
                <p style={{ 
                  marginTop: '8px', 
                  marginLeft: '28px',
                  color: test.passed ? '#155724' : '#721c24',
                  fontSize: '14px'
                }}>
                  {test.details}
                </p>
                {test.data && (
                  <pre style={{
                    marginTop: '8px',
                    marginLeft: '28px',
                    padding: '8px',
                    backgroundColor: 'white',
                    borderRadius: '4px',
                    fontSize: '12px',
                    overflow: 'auto',
                    maxHeight: '200px'
                  }}>
                    {JSON.stringify(test.data, null, 2)}
                  </pre>
                )}
              </div>
            ))}

            <div style={{ marginTop: '20px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
              <h4>What to do next:</h4>
              <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
                <li>If "Token exists" fails: Login again</li>
                <li>If "Backend health" fails: Start backend server (npm start in backend folder)</li>
                <li>If "Get user info" fails: Token expired, login again</li>
                <li>If "Get received requests" shows 0 but database has requests: Check user ID matches</li>
                <li>If all tests pass but UI doesn't show requests: Check browser console for React errors</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DebugRequests;
